export const PREV_CLICK_EVENT = 'playerClickPrevious';
export const NEXT_CLICK_EVENT = 'playerClickNext';
export const NEXT_CLIP_COMPLETE_EVENT = 'playerClipComplete';
export const X_RAY_CLICK_EVENT = 'LuxClickVideo';
export const DISABLE_CAROUSEL_EVENT = 'DisableCarousel';
export const ENABLE_CAROUSEL_EVENT = 'EnableCarousel';
export const PLAYLIST_REQUEST_EVENT = 'PlaylistRequest';
export const FORM_SHOWED_EVENT = 'formShowed';
export const FORM_CLOSED_EVENT = 'formClosed';
export const FORM_SUBMITTED_EVENT = 'formSubmitted';
export const TIMELINE_MARK_CLICK_EVENT = 'dispatchClickMark';
export const TIMELINE_MARK_START_EVENT = 'dispatchStartMark';
export const CUSTOM_TOGGLE_SWITCH_EVENT = 'dispatchCustomSwitchChange';
export const PSEUDO_FULL_SCREEN_CLOSED = 'playerPFSclosed';
export const PLAYER_ITEM_CHANGE = 'playerItemChange';
